// extracted by mini-css-extract-plugin
module.exports = {"padtb16":"styles_padtb16__HdbUb","fullFlex":"styles_fullFlex__JldVU"};